<p-toast></p-toast>
<!-- OVERLAY SCREEN -->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>


<!-- CONFIRMATION DIALOG -->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<div class="card">
    <!-- TOOLBAR OPTION -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN TABLE -->
    <p-table #dt [value]="hasActiveFilters() ? lstIncidentsFilter : lstIncidents" [globalFilterFields]="
    ['incidentId','personName','subject','body','email','zonCoord','natioCoord','userId','assignedTo', 'statusDesc'
    , 'currDateFormat' ]" [rowHover]="true" dataKey="incidentId" styleClass="p-datatable-responsive-demo"
        editMode="row"
        currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
        [showCurrentPageReport]="true" responsive="true" [paginator]="true" [rows]="10">

        <!-- CAPTION -->
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">{{translations.lbl_incidents}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </span>
            </div>

            <!-- CAPTION -->
            <span class="p-input-icon-left">
                <button type="button" *ngIf="showNewButton" pButton pRipple icon="pi pi-plus"
                    (click)="onDisplayCreateModal()" class="p-button-info p-mr-2" pTooltip="{{translations.lbl_new}}"
                    tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>

                <!-- VER ORDENES -->

                <!-- Botón para ver incidentes abiertos -->
                <p-button label="{{ showOpen ? 'Mostrando Abiertas' : 'Ver Abiertas' }}" icon="pi pi-folder-open"
                    class="p-mr-2" [style.background-color]="showOpen ? 'green' : 'blue'"
                    [style.border-color]="showOpen ? 'green' : 'blue'" [style.color]="'white'"
                    (click)="toggleFilter('open', true)">
                </p-button>

                <!-- Botón para ver incidentes solucionados -->
                <p-button label="{{ showClosed ? 'Mostrando Solucionadas' : 'Ver Solucionadas' }}" icon="pi pi-check"
                    class="p-mr-2" [style.background-color]="showClosed ? 'green' : 'blue'"
                    [style.border-color]="showClosed ? 'green' : 'blue'" [style.color]="'white'"
                    (click)="toggleFilter('closed', true)">
                </p-button>
            </span>
        </ng-template>

        <!-- HEADER -->
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="incidentId" pTooltip="{{translations.lbl_id}} {{translations.lbl_incidents}}">
                    <p-sortIcon field="incidentId">
                    </p-sortIcon>
                    <p-columnFilter type="text" field="incidentId" display="menu"></p-columnFilter>
                    {{translations.lbl_id}} {{translations.lbl_incidents}}
                </th>
                <th pSortableColumn="currDateFormat" pTooltip="{{translations.lbl_date}}">
                    <p-sortIcon field="currDateFormat">
                    </p-sortIcon>
                    <p-columnFilter type="date" field="currDateFormat" display="menu"></p-columnFilter>
                    {{translations.lbl_date}}
                </th>
                <th pSortableColumn="personName" pTooltip="{{translations.lbl_name}}">
                    <p-sortIcon field="personName">
                    </p-sortIcon>
                    <p-columnFilter type="text" field="personName" display="menu"></p-columnFilter>
                    {{translations.lbl_name}}
                </th>
                <th pSortableColumn="subject" pTooltip="{{translations.lbl_subject}}">
                    <p-sortIcon field="subject">
                    </p-sortIcon>
                    <p-columnFilter type="text" field="subject" display="menu"></p-columnFilter>
                    {{translations.lbl_subject}}
                </th>
                <th pSortableColumn="zonCoord" pTooltip="{{translations.lbl_zonal_coordinations}}">
                    <p-sortIcon field="zonCoord">
                    </p-sortIcon>
                    <p-columnFilter type="text" field="zonCoord" display="menu"></p-columnFilter>
                    C. {{translations.lbl_zonal}}
                </th>
                <th pSortableColumn="natioCoord"
                    pTooltip="{{translations.lbl_coordinations}} {{translations.lbl_national}}">
                    <p-sortIcon field="natioCoord">
                    </p-sortIcon>
                    <p-columnFilter type="text" field="natioCoord" display="menu"></p-columnFilter>
                    C. {{translations.lbl_national}}
                </th>
                <th pSortableColumn="assignedTo" pTooltip="{{translations.lbl_assigned}}">
                    <p-sortIcon field="assignedTo">
                    </p-sortIcon>
                    <p-columnFilter type="text" field="assignedTo" display="menu"></p-columnFilter>
                    {{translations.lbl_assigned}}
                </th>
                <th pSortableColumn="status" pTooltip="{{translations.lbl_status}}">
                    <p-sortIcon field="status">
                    </p-sortIcon>
                    <p-columnFilter field="status" matchMode="equals" display="menu">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-dropdown [ngModel]="value" [options]="statuses" (onChange)="filter($event.value)"
                                placeholder="Any">
                                <ng-template let-option pTemplate="item">
                                    <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                </ng-template>
                            </p-dropdown>
                        </ng-template>
                    </p-columnFilter>
                    {{translations.lbl_status}}
                </th>
                <th style="width:4rem" pTooltip="{{translations.lbl_download}} {{translations.lbl_file}}">
                    {{translations.lbl_download}} {{translations.lbl_file}}</th>
                <th style="width:4rem" pTooltip="{{translations.lbl_select}}">{{translations.lbl_select}}</th>
                <th style="width:4rem" pTooltip="{{translations.lbl_edit}}">{{translations.lbl_edit}}</th>
                <th style="width:4rem" pTooltip="{{translations.lbl_delete_record}}">{{translations.lbl_delete_record}}
                </th>
            </tr>
        </ng-template>

        <!-- BODY -->
        <ng-template pTemplate="body" let-value let-editing="editing" let-ri="rowIndex">
            <tr [pEditableRow]="value">
                <td class="body-cell">{{value.incidentId ? value.incidentId : " " }}</td>
                <td class="body-cell">{{value.currDate? (value.currDate | tovpilDate: 'd MMM y') : value.currDate}}
                </td>
                <td class="body-cell">{{value.personName ? value.personName : " "}}</td>
                <td class="body-cell"> {{value.subject ? value.subject : " "}} </td>
                <td class="body-cell">{{value.zoneDesc ? value.zoneDesc : " "}}</td>
                <td class="body-cell"> {{value.natioDesc ? value.natioDesc : " "}}</td>
                <td class="body-cell">
                    <p-badge *ngIf="value.assignedTo; else noAssigned" severity="success"
                        [value]="value.assignedTo | uppercase"></p-badge>
                    <ng-template #noAssigned>
                        <p-badge severity="danger" value="SIN ASIGNAR"></p-badge>
                    </ng-template>
                </td>

                <td class="body-cell">
                    <p-badge *ngIf="value.status" [severity]="getStatusSeverity(value.status)"
                        [value]="(value.statusDesc || ' ') | uppercase"></p-badge>
                </td>


                <td>
                    <button type="button" *ngIf="!fileNameIsEmpty(value.fileName)" pButton pRipple icon="pi pi-download"
                        (click)="onClickDownloadFile(value)" pTooltip="{{translations.lbl_download}}"></button>
                </td>
                <td>
                    <button type="button" pButton pRipple icon="pi pi-search" (click)="selectIncident(value.incidentId)"
                        pTooltip="{{translations.lbl_select}}">
                    </button>
                </td>
                <!-- EDIT BUTTON -->
                <td>
                    <button *ngIf="!editing  && value.status=='N'" pButton pRipple type="button" icon="pi pi-pencil"
                        (click)="onDisplayUpdateModal(value.incidentId)" pTooltip="{{translations.lbl_edit}}"
                        class="p-button-rounded p-button-warning p-mr-2 p-ripple p-button p-component p-button-icon-only ng-star-inserted">
                    </button>
                </td>
                <!-- DELETE BUTTON -->
                <td>
                    <button pButton icon="pi pi-trash" class="p-button-danger p-button-rounded p-mr-2"
                        (click)="deleteRecord(value.incidentId)" pTooltip="{{translations.lbl_delete_record}}"
                        *ngIf="value.status=='N'">
                    </button>
                </td>
            </tr>
        </ng-template>

        <!-- SUMMARY -->
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_there_are}} {{hasActiveFilters() ? (lstIncidentsFilter ? lstIncidentsFilter.length :
                0) :
                (lstIncidents ? lstIncidents.length : 0)}} {{translations.lbl_records}}.
            </div>
        </ng-template>
    </p-table>
</div>

<!-- MODAL CREATE -->

<!-- TODO: FALTA ETIQUETA DE TITULO -->
<p-dialog header="{{translations.lbl_new}} {{translations.lbl_incidents}}" [(visible)]="displayModal"
    styleClass="p-fluid" [modal]="true" [style]="{width: '50vw'}" [maximizable]="true" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false" (onHide)="onCloseCreateModal()">

    <div class="card">
        <!-- MAIN CONTENT -->
        <div class="p-grid">
            <!-- INFO -->
            <div class="p-col-12">
                <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1">
                    <span>{{translations.lbl_new}}</span>
                    <span class="p-text-bold">Incidencia</span>
                </div>
            </div>
        </div>
        <!-- INPUTS -->
        <div class="p-grid" [formGroup]="dataForm">
            <div class="p-col-12">
                <div class="p-fluid">
                    <!-- Personal Information Fieldset -->
                    <p-fieldset legend="{{translations.lbl_personal_information}}" class="p-fluid">
                        <div class="p-field p-grid">
                            <label for="nameModal" class="p-col-12 p-md-3">{{translations.lbl_name}} <span
                                    style="color:red">(*)</span></label>
                            <div class="p-col-12 p-md-9">
                                <input id="nameModal" formControlName="form_name" type="text" maxlength="80" pInputText
                                    placeholder="{{translations.lbl_name}}" [(ngModel)]="dataForm.form_name">
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <label for="emailModal" class="p-col-12 p-md-3">{{translations.lbl_email}} <span
                                    style="color:red">(*)</span></label>
                            <div class="p-col-12 p-md-9">
                                <input id="emailModal" formControlName="form_email" type="email" maxlength="60"
                                    pInputText placeholder="{{translations.lbl_email}}"
                                    [(ngModel)]="dataForm.form_email">
                            </div>
                        </div>
                    </p-fieldset>

                    <!-- Coordinations Fieldset -->
                    <p-fieldset legend="{{translations.lbl_coordinations}}" class="p-fluid">
                        <div class="p-field p-grid">
                            
                            <!-- Zonal Coordination -->
                            <label for="zonalCoordination"
                                class="p-col-12 p-md-3">{{translations.lbl_zonal_coordinations}}</label>
                            <div class="p-col-12 p-md-9">
                                <p-dropdown id="zonalCoordination" [options]="zonalCoordinations"
                                    placeholder="{{translations.lbl_select}} {{translations.lbl_zonal_coordinations}}"
                                    formControlName="form_zonal_coordination" optionLabel="store.descri"
                                    [showClear]="true" (onChange)="_assigNationalCoordination($event)"
                                    [(ngModel)]="dataForm.form_zonal_coordination"></p-dropdown>
                            </div>
                        </div>

                        <!-- Coordination -->
                        <div class="p-field p-grid">
                            <label for="nationalCoordination" class="p-col-12 p-md-3">{{translations.lbl_coordination}}</label>
                            <div class="p-col-12 p-md-9">
                                <p-dropdown id="nationalCoordination" [options]="nationalCoordinations" [filter]="true"
                                    placeholder="{{translations.lbl_select}} {{translations.lbl_coordination}}"
                                    formControlName="form_national_coordination" optionLabel="store.descri"
                                    [showClear]="true" [(ngModel)]="dataForm.form_national_coordination"></p-dropdown>
                            </div>
                        </div>
                    </p-fieldset>

                    <!-- Incident Details Fieldset -->
                    <p-fieldset legend="{{translations.lbl_incident_details}}" class="p-fluid">
                        <!-- DROPDOWN Function Application-->
                        <div class="p-field p-grid">
                            <label for="statusModal" class="p-col-12 p-md-3">{{translations.lbl_function}}</label>
                            <div class="p-col-12 p-md-9">
                                <p-dropdown id="statusModal" [options]="inciRoles"
                                    placeholder="{{translations.lbl_select}} {{translations.lbl_function}}"
                                    formControlName="form_application" optionLabel="value" [showClear]="true"
                                    [(ngModel)]="dataForm.form_application"></p-dropdown>
                            </div>
                        </div>

                        <!-- DROPDOWN Type-->
                        <div class="p-field p-grid">
                            <label for="statusModal" class="p-col-12 p-md-3">{{translations.lbl_type}}</label>
                            <div class="p-col-12 p-md-9">
                                <p-dropdown id="statusModal" [options]="inciTypes"
                                    placeholder="{{translations.lbl_select}} {{translations.lbl_type}}"
                                    formControlName="form_type" optionLabel="value" [showClear]="true"
                                    [(ngModel)]="dataForm.form_type"></p-dropdown>
                            </div>
                        </div>

                        <!-- DROPDOWN Severity-->
                        <div class="p-field p-grid">
                            <label for="statusModal" class="p-col-12 p-md-3">{{translations.lbl_severity}}</label>
                            <div class="p-col-12 p-md-9">
                                <p-dropdown id="statusModal" [options]="inciSeverities"
                                    placeholder="{{translations.lbl_select}} {{translations.lbl_severity}}"
                                    formControlName="form_severity" optionLabel="value" [showClear]="true"
                                    [(ngModel)]="dataForm.form_severity"></p-dropdown>
                            </div>
                        </div>

                        <!-- DROPDOWN Priority-->
                        <div class="p-field p-grid">
                            <label for="statusModal" class="p-col-12 p-md-3">{{translations.lbl_priority}}</label>
                            <div class="p-col-12 p-md-9">
                                <p-dropdown id="statusModal" [options]="inciPriorities"
                                    placeholder="{{translations.lbl_select}} {{translations.lbl_priority}}"
                                    formControlName="form_priority" optionLabel="value" [showClear]="true"
                                    [(ngModel)]="dataForm.form_priority"></p-dropdown>
                            </div>
                        </div>
                    </p-fieldset>

                    <!-- Summary Fieldset -->
                    <p-fieldset legend="{{translations.lbl_summary}}" class="p-fluid">
                        <div class="p-field p-grid">
                            <label for="resumenModal" class="p-col-12 p-md-3">{{translations.lbl_summary}} <span
                                    style="color:red">(*)</span></label>
                            <div class="p-col-12 p-md-9">
                                <input id="resumenModal" formControlName="form_review" type="text" maxlength="80"
                                    pInputText [(ngModel)]="dataForm.form_review"
                                    placeholder="{{translations.lbl_subject}}">
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <label for="commentsModal" class="p-col-12 p-md-3">{{translations.lbl_description}}</label>
                            <div class="p-col-12 p-md-9">
                                <textarea id="commentsModal" formControlName="form_description" rows="5" pInputTextarea
                                    style="min-height: 100px; width: 100%; resize: vertical;" maxlength="800" #myInput
                                    [(ngModel)]="dataForm.form_description"
                                    placeholder="{{translations.lbl_subject}}"></textarea>
                                <div class="text-right">
                                    <small>{{myInput.value.length}} / 300</small>
                                </div>
                            </div>
                        </div>
                    </p-fieldset>

                    <!-- Attach File Fieldset -->
                    <p-fieldset legend="{{translations.lbl_attach_file}}" class="p-fluid">
                        <div class="p-field p-grid">
                            <label for="statusModal" class="p-col-12 p-md-3">Adjunte archivo</label>
                            <div class="p-col-12 p-md-9">
                                <input id="imageUrl" name="imageUrl" type="file" accept="*/*"
                                    (change)="onFileSelected($event)" />
                            </div>
                        </div>
                    </p-fieldset>
                </div>
            </div>
        </div>

    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{translations.lbl_back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="onCloseCreateModal()"></button>

        <button pButton pRipple type="button" icon="pi pi-check" label="{{translations.lbl_save}}"
            class="p-button-raised p-button-success" (click)="onSave()"></button>
    </ng-template>
</p-dialog>